import { Navigate, useLocation } from "react-router-dom"

import {
  modulesForPath,
  useAllowedModules,
  useAllowedNavigation,
} from "./module-access"

const Forbidden = () => (
  <div className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-2 text-center">
    <h2 className="text-xl font-semibold">Akses ditolak</h2>
    <p className="text-muted-foreground text-sm">
      Role Anda tidak memiliki akses ke halaman ini. Hubungi admin bila menurut
      Anda ini keliru.
    </p>
  </div>
)

export const ModuleGuard = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation()
  const { allowed, isLoading } = useAllowedModules()
  const { items } = useAllowedNavigation()

  if (isLoading) return null

  const required = modulesForPath(pathname)
  const canAccess =
    required.length === 0 || required.some((module) => allowed.has(module))

  if (canAccess) return children

  const fallback = items[0]?.items[0]?.href ?? items[0]?.href
  if (pathname === "/app" && fallback) {
    return <Navigate to={fallback} replace />
  }

  return <Forbidden />
}
